import { getTrackingService } from '@gig/magic-common';
import { EXPERIMENT_QUERY, EXPERIMENT_QUERY_ACTIVE_VARIANT, EXPERIMENT_QUERY_VARIANT_ENABLED } from '@gig/magic-messages';

var EXPERIMENTS_KEY = 'wand-experiments-';
var ExperimentService = /** @class */ (function () {
    function ExperimentService(experimentsConfig) {
        this.experiments = {};
        this.runningExperiments = {};
        this.accessedExperiments = new Set();
        this.registerExperimentsQueries();
        if (experimentsConfig) {
            this.initializeExperiments(experimentsConfig);
        }
    }
    ExperimentService.prototype.registerExperimentsQueries = function () {
        var _this = this;
        window.queryBus.subscribe(EXPERIMENT_QUERY, function () {
            return _this.experiments;
        });
        window.queryBus.subscribe(EXPERIMENT_QUERY_ACTIVE_VARIANT, function (name) {
            if (!name.payload) {
                return;
            }
            return _this.getActiveVariant(name.payload);
        });
        window.queryBus.subscribe(EXPERIMENT_QUERY_VARIANT_ENABLED, function (name) {
            if (!name.payload) {
                return;
            }
            return _this.enabledVariant(name.payload);
        });
    };
    ExperimentService.prototype.initializeExperiments = function (experimentsConfig) {
        var _this = this;
        this.experiments = experimentsConfig;
        this.runningExperiments = {};
        // Choose all experiments immediately
        Object.keys(this.experiments).forEach(function (experimentKey) {
            var experiment = _this.experiments[experimentKey];
            var variantName = _this.getCurrentStoredVariant(experimentKey);
            var variant = experiment.variants.find(function (_a) {
                var name = _a.name;
                return name === variantName;
            });
            if (variantName && variant) {
                _this.runningExperiments[experiment.name] = variant;
            }
            else {
                var chosenVariant = _this.getRandomVariant(experiment.variants);
                _this.setRunningExperiment(experiment.name, chosenVariant);
            }
        });
    };
    ExperimentService.prototype.getExperiment = function (name) {
        return this.experiments[name] || false;
    };
    ExperimentService.prototype.getActiveVariant = function (name) {
        var config = this.getExperiment(name);
        if (!config) {
            return false;
        }
        var variant = this.runningExperiments[name];
        if (!variant) {
            return false;
        }
        this.trackExperiment(config, variant);
        return variant;
    };
    ExperimentService.prototype.enabledVariant = function (name) {
        var activeExperiment = this.getActiveVariant(name);
        if (!activeExperiment) {
            return false;
        }
        return !!activeExperiment.name;
    };
    ExperimentService.prototype.trackExperiment = function (config, variant) {
        this.accessedExperiments.add(config.id + "." + variant.id);
        getTrackingService().setExperiments(Array.from(this.accessedExperiments).join('!'));
    };
    ExperimentService.prototype.getRandomVariant = function (variants) {
        var length = variants.length;
        var index = Math.floor(Math.random() * length);
        return variants[index];
    };
    ExperimentService.prototype.setRunningExperiment = function (name, variant) {
        this.runningExperiments[name] = variant;
        try {
            localStorage.setItem(this.getExperimentKey(name), variant.name);
        }
        catch (e) {
            // ignore
        }
    };
    ExperimentService.prototype.getExperimentKey = function (name) {
        return "" + EXPERIMENTS_KEY + name;
    };
    ExperimentService.prototype.getCurrentStoredVariant = function (name) {
        try {
            var storageKey = this.getExperimentKey(name);
            return localStorage.getItem(storageKey) || false;
        }
        catch (e) {
            // Ignore. Running in incognito safari or something which doesn't have localStorage available.
            return false;
        }
    };
    return ExperimentService;
}());

export { ExperimentService };
